import { Button } from "@repo/ui";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export function Unauthorized() {
  const { user, isLoading, signOut } = useAuth();

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-16 flex items-center justify-center min-h-[60vh]">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-16 flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <CardTitle className="text-6xl font-bold text-muted-foreground">403</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <h1 className="text-2xl font-semibold">Unauthorized Access</h1>
          <p className="text-muted-foreground">
            You don't have permission to access this resource.
          </p>

          {user && (
            <div className="pt-2 pb-4">
              <div className="text-sm text-muted-foreground space-y-1">
                <p>
                  <span className="font-medium">Logged in as:</span> {user.email}
                </p>
                {user.role && (
                  <p>
                    <span className="font-medium">Role:</span> {user.role}
                  </p>
                )}
                <p className="text-xs opacity-70">User ID: {user.id}</p>
              </div>
            </div>
          )}

          <div className="pt-4 flex flex-col gap-3">
            <Button asChild>
              <Link to="/">Return to Home</Link>
            </Button>
            <Button variant="outline" onClick={() => signOut()}>
              Sign Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
